
require("./../../node_modules/@module-federation/nextjs-mf/src/include-defaults.js");
import { memo } from 'react';
import dynamic from 'next/dynamic';
import { GetServerSidePropsContext } from 'next';
import { dehydrate, QueryClient, DehydratedState } from '@tanstack/react-query';

import SEO from 'global/SEO';
import { glossaryMetaTags } from 'global/SEO/constants';
import GlossaryFeature from 'features/glosarry';
import { GLOSSARY_QUERY_KEY } from 'features/glosarry/constants';
import { getLetterParameters } from 'utils/glossary';
import { getItemByLetter } from 'lib/api/glossary';

const GlossaryLayout = dynamic(() => import('features/glosarry/Layout'), {
  ssr: false,
});

interface IGlossaryPageProps {
  dehydratedState: DehydratedState;
}

function Glossary({ dehydratedState }: IGlossaryPageProps) {
  return (
    <>
      <SEO title={glossaryMetaTags.title} customTitle />

      <GlossaryLayout dehydratedState={dehydratedState}>
        <GlossaryFeature />
      </GlossaryLayout>
    </>
  );
}

export async function getServerSideProps({
  params,
}: GetServerSidePropsContext) {
  const { letter } = getLetterParameters(params);
  const queryClient = new QueryClient();

  try {
    await queryClient.prefetchQuery(
      [GLOSSARY_QUERY_KEY.TERMS, letter],
      async () => {
        const { data } = await getItemByLetter(letter);
        return data.data || {};
      },
    );
  } catch (error) {
    throw new Error('Failed to prefetch glossaries data');
  }

  return {
    props: {
      dehydratedState: dehydrate(queryClient),
    },
  };
}

export default memo(Glossary);
